import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { TrendingUp } from "react-feather";
import TableComponent from "../../../components/widgets/table/index";
import DownloadSettlement from "../../../components/widgets/modals/DownloadSettlement";

function AccountingPolicies() {
  const [showModal, setShowModal] = useState(false);
  const [selectedUnderwriterId, setSelectedUnderwriterId] = useState(null);

  // Demo data instead of API call
  const policies = [
    {
      id: 1,
      underwriterName: "AIG Insurance",
      totalVolume: 120000,
      totalUnsettled: 20000,
      todayVolume: 5000,
      weeklyVolume: 25000,
      monthlyVolume: 85000,
    },
    {
      id: 2,
      underwriterName: "Jubilee Insurance",
      totalVolume: 95000,
      totalUnsettled: 15000,
      todayVolume: 3000,
      weeklyVolume: 18000,
      monthlyVolume: 62000,
    },

  ];

  // Settlement data for the table
  const settlementData = [
    {
      id: 1,
      total: policies.reduce((sum, pol) => sum + (pol.totalVolume - pol.totalUnsettled || 0), 0),
      processing: 25000,
      pending: policies.reduce((sum, pol) => sum + (pol.totalUnsettled || 0), 0),
    },
  ];

  // Loading state is no longer needed with static data
  const isLoading = false;
  const isError = false;

  if (isLoading) {
    return <div>Loading policies...</div>;
  }

  if (isError) {
    return <div>Error loading policies</div>;
  }

  // Ensure policies is an array; fallback to empty array if undefined
  const policyData = Array.isArray(policies) ? policies : [];

  const tableFields = [
    { name: "#" },
    { name: "Name" },
    { name: "Total Volume" },
    { name: "Total Unsettled" },
    { name: "Action" },
  ];

  const tableRowData = [
    { type: "index" }, // # column as index
    { type: "text", field: "underwriterName" },
    { type: "currency", field: "totalVolume" },
    { type: "currency", field: "totalUnsettled" },
    {
      type: "action",
      field: "id",
      actions: [
        {
          method: (id) => {
            setSelectedUnderwriterId(id);
            setShowModal(true);
          },
          field: "id",
          title: "Download Settlement",
        },
      ],
    },
  ];

  const settlementTableFields = [
    { name: "Total Paid To Underwriters" },
    { name: "Processing" },
    { name: "Pending" },
  ];

  const settlementTableRowData = [
    { type: "currency", field: "total" },
    { type: "currency", field: "processing" },
    { type: "currency", field: "pending" },
  ];

  // Calculate summary metrics
  const totalVolume = policyData.reduce((sum, pol) => sum + (pol.totalVolume || 0), 0);
  const totalToday = policyData.reduce((sum, pol) => sum + (pol.todayVolume || 0), 0);
  const thisWeekVolume = policyData.reduce((sum, pol) => sum + (pol.weeklyVolume || 0), 0);
  const thisMonthVolume = policyData.reduce((sum, pol) => sum + (pol.monthlyVolume || 0), 0);

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUnderwriterId(null);
  };

  return (
    <div className="card shadow p-4">
      <div className="mb-4">
        <h4 className="mb-1">This Shows Your Policy Summaries</h4>
        <p className="text-muted mb-4">Volume</p>

        <Row className="mb-4">
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-primary me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {totalVolume.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-info me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Today</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {totalToday.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-success me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>This Week</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {thisWeekVolume.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="shadow-sm mb-3" style={{ borderRadius: "10px", border: "none" }}>
              <Card.Body className="d-flex align-items-center">
                <TrendingUp size={40} className="text-warning me-3" />
                <div>
                  <Card.Title style={{ fontSize: "1.0rem", fontWeight: "600" }}>This Month</Card.Title>
                  <Card.Text style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    KES {thisMonthVolume.toLocaleString()}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <p className="text-muted mb-3">Settlement (Shows How Sttlements has been done to Underwriters)</p>

        <TableComponent
          title="Settlement Details"
          table_fields={settlementTableFields}
          table_data={settlementData}
          row_data={settlementTableRowData}
          pageSize={10}
        />

        <p className="text-muted mb-3 mt-4">Underwriters (Shows policy Performance Per Underwriter)</p>
      </div>

      <TableComponent
        title="Policy Details"
        table_fields={tableFields}
        table_data={policyData}
        row_data={tableRowData}
        pageSize={10}
      />

      <DownloadSettlement show={showModal} onHide={handleCloseModal} underwriterId={selectedUnderwriterId} />
    </div>
  );
}

export default AccountingPolicies;